import React from "react";
import "./ThankYou.css";
const ThankYouPage = () => {
  return (
    <div className="thankYouPageContainer">
      <img
        src="https://www.247digitize.com/wp-content/uploads/2022/01/world-languages.jpg"
        alt=""
      />
      <p>
        Thanks a bunch for filling that out. It means a lot to us, just like you
        do! We really appreciate you giving us a moment of your time today.
        Thanks for being you.
      </p>
      <p>Our Language Advisor will get back to you within 24 Hrs.</p>
    </div>
  );
};

export default ThankYouPage;
